import { ICommand, IDefineCommand, IQuery, IQueryMediator } from 'core-ts-types';
import { IAppointmentLocationsOrganizersDatasource } from '../datasources/appointment_location_staff_datasource';
import { AppointmentsCommandServant } from '../servants/appointments_command_servant';
import { TAppointmentLocationsOrganizersUsersource } from '../usersources/appointment_location_staff_usersource';
import { TAppointmentReasonUsersource } from '../usersources/appointment_reason_usersource';

angular
  .module('capability-ng-appointments')
  .factory(
    'loadAppointmentsLocationsCommand',
    (
      defineCommand: IDefineCommand,
      $http: ng.IHttpService,
      QueryMediator: IQueryMediator,
      ngAppointmentsCommandServant: AppointmentsCommandServant,
      log: any,
      ngAppointmentReasonUsersource: TAppointmentReasonUsersource,
      ngAppointmentLocationsOrganizersDatasource: IAppointmentLocationsOrganizersDatasource
    ): ICommand => {
      return defineCommand('loadAppointmentsLocationsCommand', (deferred: ng.IDeferred<any>): void => {
        const requestConfig = {
          url: 'scheduler_locations',
          method: 'GET',
          params: ngAppointmentsCommandServant.locationsCommandParams
        };
        ngAppointmentsCommandServant
          .request(requestConfig)
          .then(({ data }: ng.IHttpPromiseCallbackArg<any>) => {
            ngAppointmentLocationsOrganizersDatasource.clear().write(data);
            deferred.resolve(QueryMediator.runQueries(ngAppointmentLocationsOrganizersDatasource));
          })
          .catch(() => {
            log.error('Unable to get locations and organizers/staff Data.');
            deferred.reject();
          });
      });
    }
  );



// WEBPACK FOOTER //
// ./app/vendor/capability-ng-appointments/src/commands/load_appointments_locations_command.ts